import { useInterpret } from "@xstate/react";
import { createContext } from "react";
import { InterpreterFrom } from "xstate";

import { catImportMachine } from "./catImport.state";
import { legacyOrderImportMachine } from "./legacyOrderImport.state";
import { legacyOrderProductImportMachine } from "./legacyOrderProductImport.state";
import { legacyRewardImportMachine } from "./legacyReward.state";
import { legacyUserImportMachine } from "./legacyUserImport.state";
import { productImportMachine } from "./productImport.state";
import { productCatAssociateImportMachine } from "./productCatAssociateImport.state";
import { productImageImportMachine } from "./productMediaImport.state";
import { brandImportMachine } from "./brandImport.state";

// Ref: https://stately.ai/blog/how-to-manage-global-state-with-xstate-and-react

interface RootStateType {
  productImportService: InterpreterFrom<typeof productImportMachine>;
  productCatAssociateImportService: InterpreterFrom<typeof productCatAssociateImportMachine>;
  productImageImportService: InterpreterFrom<typeof productImageImportMachine>;
  catImportService: InterpreterFrom<typeof catImportMachine>;
  brandImportService: InterpreterFrom<typeof brandImportMachine>;
  legacyUserImportService: InterpreterFrom<typeof legacyUserImportMachine>;
  legacyOrderImportService: InterpreterFrom<typeof legacyOrderImportMachine>;
  legacyOrderProductImportService: InterpreterFrom<typeof legacyOrderProductImportMachine>;
  legacyRewardImportService: InterpreterFrom<typeof legacyRewardImportMachine>;
}

export const RootStateContext = createContext({} as RootStateType);

export const GlobalStateProvider = (props) => {
  const productImportService = useInterpret(productImportMachine);
  const productImageImportService = useInterpret(productImageImportMachine);
  const productCatAssociateImportService = useInterpret(productCatAssociateImportMachine);
  const catImportService = useInterpret(catImportMachine);
  const brandImportService = useInterpret(brandImportMachine);
  const legacyUserImportService = useInterpret(legacyUserImportMachine);
  const legacyOrderImportService = useInterpret(legacyOrderImportMachine);
  const legacyOrderProductImportService = useInterpret(legacyOrderProductImportMachine);
  const legacyRewardImportService = useInterpret(legacyRewardImportMachine);

  return (
    <RootStateContext.Provider
      value={{
        productImportService,
        productImageImportService,
        productCatAssociateImportService,
        catImportService,
        brandImportService,
        legacyUserImportService,
        legacyOrderImportService,
        legacyOrderProductImportService,
        legacyRewardImportService,
      }}
    >
      {props.children}
    </RootStateContext.Provider>
  );
};
